module.exports = __webpack_public_path__ + "static/media/moovit.ce2a40e7.png";